import React from 'react';
import { useTranslation } from 'react-i18next';
import { Menu, MenuItem } from '@mui/material';

import { ReactComponent as EditIcon } from 'assets/icons/Edit.svg';
import { ReactComponent as DeleteIcon } from 'assets/icons/Delete.svg';

import { useStyles } from '../styles';

interface WorkerActionsMenuProps {
  anchorEl: null | HTMLElement;
  onClose: () => void;
  onEdit: () => void;
  onDelete: () => void;
}

const WorkerActionsMenu: React.FC<WorkerActionsMenuProps> = ({ anchorEl, onClose, onEdit, onDelete }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      className={classes.actionsMenu}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      disableScrollLock={true}
      disableRestoreFocus={true}
      onClose={onClose}
    >
      <MenuItem data-testid="worker-edit-button" onClick={onEdit} className={classes.actionsMenuItem}>
        <EditIcon />
        {t('workerStatus.actions.editDetails')}
      </MenuItem>
      <MenuItem data-testid="worker-delete-button" onClick={onDelete} className={classes.actionsMenuItem}>
        <DeleteIcon />
        {t('workerStatus.actions.deleteWorker')}
      </MenuItem>
    </Menu>
  );
};

export default WorkerActionsMenu;
